'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TagPickerContextProvider: function() {
        return TagPickerContextProvider;
    },
    tagPickerContextDefaultValue: function() {
        return tagPickerContextDefaultValue;
    },
    useTagPickerContext_unstable: function() {
        return useTagPickerContext_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactcontextselector = require("@fluentui/react-context-selector");
const tagPickerContextDefaultValue = {
    triggerRef: /*#__PURE__*/ _react.createRef(),
    popoverRef: /*#__PURE__*/ _react.createRef(),
    targetRef: /*#__PURE__*/ _react.createRef(),
    tagPickerGroupRef: /*#__PURE__*/ _react.createRef(),
    secondaryActionRef: /*#__PURE__*/ _react.createRef(),
    open: false,
    clearSelection: ()=>null,
    getOptionById: ()=>undefined,
    selectedOptions: [],
    selectOption: ()=>null,
    setHasFocus: ()=>null,
    setOpen: ()=>null,
    setValue: ()=>null,
    value: undefined,
    popoverId: '',
    size: 'medium',
    appearance: 'outline',
    disabled: false
};
const TagPickerContext = (0, _reactcontextselector.createContext)(undefined);
const TagPickerContextProvider = TagPickerContext.Provider;
const useTagPickerContext_unstable = (selector)=>(0, _reactcontextselector.useContextSelector)(TagPickerContext, (ctx = tagPickerContextDefaultValue)=>selector(ctx));
